import React from "react";
import "./App.css";
import Footer from "./Footer";
import logoImage from "./images/WazzaScore_Logo2.png";

function NotFoundPage() {
  return (
    <div className="not-found-page">
      <header className="privacyHeader">
        <div className="smallLogo" style={{ textAlign: "left", padding: "1rem" }}>
          <a href="/">
            <img
              src={logoImage}
              alt="WazzaScore Logo"
              style={{
                width: "150px",
                height: "auto",
                maxWidth: "80%",
                cursor: "pointer",
              }}
            />
          </a>
        </div>
      </header>

      <main
        style={{
          padding: "2rem",
          textAlign: "center",
          minHeight: "60vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <h1 style={{ fontSize: "3rem", marginBottom: "1rem" }}>404</h1>
        <p style={{ fontSize: "1.2rem", color: "#666", marginBottom: "2rem" }}>
          Oops, this page did not show for Monday practice. 
        </p>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <a
            href="/"
            style={{
              padding: "0.75rem 1.5rem",
              backgroundColor: "#1cac53",
              color: "#fff",
              borderRadius: "8px",
              textDecoration: "none",
              fontWeight: "bold",
              width: "50%",
              maxWidth: "300px", // optional: to avoid it getting too wide on large screens
              textAlign: "center",
            }}
          >
            Go to home page
          </a>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default NotFoundPage;
